module.exports = __webpack_public_path__ + "img/Case.dc18c1f7.png";